import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class StudentAttendanceByDateBadges {
	constructor (div, studentId) {
		this.div = div;
		DojoDeshi.instance().RPC().StudentAttendanceByDate(studentId).then(
			(res)=>{
				this.div.innerHTML = '';
				let d = new Date();
				let dt = Date.parse(res[0][0].Date);
				d.setTime(dt);
				let future = [];
				// if (0<=d.getDay()) {
				// 	for (let i=7-d.getDay(); i>0; i--) {
				// 		let f = dt + i * 24*60*60*1000;
				// 		let fd = new Date();
				// 		fd.setTime(dt + i*24*60*60*1000);
				// 		future.push({Date:fd, Count:-1});
				// 	}
				// }
				let el = document.createElement('div');
				el.className = "attendance-row";
				let badge = (att)=> {
					el.appendChild(this.badge(att));
				}
				// console.log("future = ", future);
				// console.log("res[0][0] = ", res[0][0]);
				future.forEach( badge );
				res[0].forEach( badge );
				this.div.innerHTML = '';
				this.div.appendChild(el);
			}
			, (err)=>{
				console.error(err);
				div.appendChild(document.createTextNode(err));
			}).catch( (err)=> {
				console.error(err);
				// alert(`ERROR: ${err.message}`);
			});
	}
	badge(att) {
		let e = document.createElement('div');
		e.className = 'attendance-badge attendance-' + 
		(att.Count>0 ? 'present' : 
			(att.Count==0 ? 'absent':'future'));
		return e;
	}
	renderWeekBadges(items, el) {
		let badge = (a)=>{
			let e = document.createElement('div');
			e.className = 'attendance-badge attendance-' + 
				(a.Count>0 ? 'present' : 
					(a.Count==0 ? 'absent':'future'));
			el.appendChild(e);
		};
	}
}

window.StudentAttendanceByDateBadges = StudentAttendanceByDateBadges;